import { type ReactNode } from 'react';
import { cn } from '../../utils/cn';

export interface StatProps {
  readonly label: ReactNode;
  readonly value: ReactNode;
  readonly delta?: ReactNode;
  readonly deltaTone?: 'positive' | 'negative' | 'neutral';
  readonly icon?: ReactNode;
  readonly className?: string;
}

const DELTA_TONE = {
  positive: 'text-success',
  negative: 'text-danger',
  neutral: 'text-ink-3',
} as const;

export function Stat({ label, value, delta, deltaTone = 'neutral', icon, className }: StatProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-1.5 p-4 rounded-xl bg-surface border border-hairline',
        className,
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <div className="text-[11px] uppercase tracking-wider font-bold text-ink-3 font-mono">
          {label}
        </div>
        {icon ? <div className="text-ink-3">{icon}</div> : null}
      </div>
      <div className="text-[28px] font-extrabold leading-none text-ink tabular-nums">{value}</div>
      {delta ? (
        <div className={cn('text-[12px] font-semibold', DELTA_TONE[deltaTone])}>{delta}</div>
      ) : null}
    </div>
  );
}
